<template>
	<div v-if="showBox" data-id="1" style="position: fixed; display: flex; align-items: center; border: 2px solid #ccc; border-radius: 4px; 
	z-index: 10; width: 90%; height: 90%; top:3%; left: 3%; padding: 2%; background-color: #fff;">
		<div class="btnclose1" @click="clsoeCropper">
			<img :src="'./images/close.png'" alt="" style="width: 100%;">
		</div>

		<div class="cropper-content">
			<div class="cropper-box">
				<div class="cropper">
					<vue-cropper ref="cropper" :img="option.img" :outputSize="option.outputSize"
						:outputType="option.outputType" :info="option.info" :canScale="option.canScale"
						:autoCrop="option.autoCrop" :autoCropWidth="option.autoCropWidth"
						:autoCropHeight="option.autoCropHeight" :fixed="option.fixed" :fixedNumber="option.fixedNumber"
						:full="option.full" :fixedBox="option.fixedBox" :canMove="option.canMove"
						:canMoveBox="option.canMoveBox" :original="option.original" :centerBox="option.centerBox"
						:height="option.height" :infoTrue="option.infoTrue" :maxImgSize="option.maxImgSize"
						:enlarge="option.enlarge" :mode="option.mode" @realTime="realTime" @imgLoad="imgLoad">
					</vue-cropper>
				</div>
				<!--底部操作工具按钮-->
				<div class="footer-btn">
					<div class="scope-btn">
						<el-button size="mini" type="danger" plain icon="el-icon-upload" >
							<el-upload style="display: inline-block; margin-right: 20px;" action="" :http-request="uploadTemp"
								:on-success="uploadFiles" :show-file-list="false" name="image">
								上传新图片
							</el-upload>
						</el-button>
						<el-button size="mini" type="danger" plain icon="el-icon-zoom-in" @click="changeScale(1)">放大
						</el-button>
						<el-button size="mini" type="danger" plain icon="el-icon-zoom-out" @click="changeScale(-1)">缩小
						</el-button>
						<el-button size="mini" type="danger" plain @click="rotateLeft">↺ 左旋转</el-button>
						<el-button size="mini" type="danger" plain @click="rotateRight">↻ 右旋转</el-button>
					</div>
					<div class="upload-btn">
						<el-button size="mini" type="success" @click="uploadImg('blob')">确认裁剪 <i
								class="el-icon-upload"></i>
						</el-button>
					</div>
				</div>
			</div>
			<!--预览效果图-->
			<div class="show-preview">
				<div :style="previews.div" class="preview">
					<img :src="previews.url" :style="previews.img">
				</div>
				<div style="position: absolute; bottom: 50px;">
					实时效果图
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		VueCropper
	} from 'vue-cropper'
	export default {
		name: "CropperImage",
		components: {
			VueCropper
		},
		props: ['ourl',"drag"],
		data() {
			return {
				name: "dzzj",
				previews: {},
				showBox:false,
				option: {
					img: '', //裁剪图片的地址
					outputSize: 1, //裁剪生成图片的质量(可选0.1 - 1)
					outputType: 'jpeg', //裁剪生成图片的格式（jpeg || png || webp）
					info: true, //图片大小信息
					canScale: true, //图片是否允许滚轮缩放
					autoCrop: true, //是否默认生成截图框
					autoCropWidth: 358, //默认生成截图框宽度
					autoCropHeight: 441, //默认生成截图框高度
					fixed: true, //是否开启截图框宽高固定比例
					fixedNumber: [358, 441], //截图框的宽高比例
					full: false, //false按原比例裁切图片，不失真
					fixedBox: true, //固定截图框大小，不允许改变
					canMove: true, //上传图片是否可以移动
					canMoveBox: true, //截图框能否拖动
					original: false, //上传图片按照原始比例渲染
					centerBox: false, //截图框是否被限制在图片里面
					height: true, //是否按照设备的dpr 输出等比例图片
					infoTrue: false, //true为展示真实输出图片宽高，false展示看到的截图框宽高
					maxImgSize: 3000, //限制图片最大宽度和高度
					enlarge: 1, //图片根据截图框输出比例倍数
					mode: '358px 441px', //图片默认渲染方式
				},
				afterUrl: ""
			};
		},
		mounted() {
			console.log(this.ourl)
			this.option.img = this.ourl
			this.option.fixed = this.drag?false:true
			this.option.fixedBox = this.option.fixed
			this.option.autoCropWidth = 500
			this.option.autoCropHeight = 500
			this.option.fixedNumber = [500,500]
			this.option.mode = '500px 500px'
			this.option.enlarge =5
			this.showBox = false
			setTimeout(()=>{
				this.showBox = true
				this.$nextTick(()=>{
					$(".cropper-box").height(500)
					$(".cropper").height(500)
				})
			},300)
			
			
			
		},
		methods: {
			//初始化函数
			imgLoad(msg) {
				console.log("工具初始化函数=====" + msg)
			},
			//图片缩放
			changeScale(num) {
				num = num || 1
				this.$refs.cropper.changeScale(num)
			},
			//向左旋转
			rotateLeft() {
				this.$refs.cropper.rotateLeft()
			},
			//向右旋转
			rotateRight() {
				this.$refs.cropper.rotateRight()
			},
			//实时预览函数
			realTime(data) {
				this.previews = data
			},
			//选择图片
			selectImg(e) {
				let file = e.target.files[0]
				if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
					this.$message({
						message: '图片类型要求：jpeg、jpg、png',
						type: "error"
					});
					return false
				}
				//转化为blob
				let reader = new FileReader()
				reader.onload = (e) => {
					let data
					if (typeof e.target.result === 'object') {
						data = window.URL.createObjectURL(new Blob([e.target.result]))
					} else {
						data = e.target.result
					}
					this.option.img = data
				}
				//转化为base64
				reader.readAsDataURL(file)
			},
			//上传图片
			uploadImg(type) {
				let _this = this;
				if (type === 'blob') {
					//获取截图的base64数据
					this.$refs.cropper.getCropData(async (data) => {
						this.$http.post("/api/save_base64_img", {
							base64_img: data
						}).then(res => {

							this.afterUrl = res.data.url
							this.clsoeCropper()
						})
					})
				}
			},
			clsoeCropper() {
				console.log(this.afterUrl)
				this.$emit("getImage", this.afterUrl)
			},
			uploadFiles(e) {
				
				let imgurl =e.src.replace("zhaosheng-saas.oss-cn-hangzhou.aliyuncs.com", window.location.host)
				imgurl = imgurl.replace("https:", window.location.protocol)
				this.option.img = imgurl
				this.option.fixed = this.drag?false:true
				this.option.fixedBox = this.option.fixed
				this.option.autoCropWidth = 500
				this.option.autoCropHeight = 500
				this.option.fixedNumber = [500,500]
				this.option.mode = '500px 500px'
				this.option.enlarge =5
				this.showBox = true
				this.$nextTick(()=>{
					$(".cropper-box").height(500)
					$(".cropper").height(500)
				})
			},
		},
	}
</script>

<style scoped>
	.cropper-content {
		margin: 0 auto;
		display: flex;
		display: -webkit-flex;
		justify-content: flex-end;



	}

	.cropper-box {
		flex: 1;
		width: 100%;
		height: 600px;

	}

	.cropper {
		width: auto;
		height: 600px;
	}

	.show-preview {
		flex: 1;
		-webkit-flex: 1;
		display: flex;
		display: -webkit-flex;
		justify-content: center;
		position: relative;
		margin-left: 20px;

	}

	.preview {
		overflow: hidden;
		border: 1px solid #67c23a;
		background: #cccccc;
		margin-top: 50px;
	}

	.footer-btn {
		margin-top: 30px;
		display: flex;
		display: -webkit-flex;
		justify-content: flex-end;


	}

	.scope-btn {
		display: flex;
		display: -webkit-flex;
		justify-content: space-between;
		padding-right: 10px;
	}

	.upload-btn {
		flex: 1;
		-webkit-flex: 1;
		display: flex;
		display: -webkit-flex;
		justify-content: center;
	}

	.btn {
		outline: none;
		display: inline-block;
		line-height: 1;
		white-space: nowrap;
		cursor: pointer;
		-webkit-appearance: none;
		text-align: center;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		outline: 0;
		-webkit-transition: .1s;
		transition: .1s;
		font-weight: 500;
		padding: 8px 15px;
		font-size: 12px;
		border-radius: 3px;
		color: #fff;
		background-color: #409EFF;
		border-color: #409EFF;
		margin-right: 10px;
	}

	.btnclose1 {
		width: 30px;
		height: 30px;
		position: absolute;
		top: 20px;
		right: 20px;
		cursor: pointer;

	}
</style>
